import { useSetState } from "react-use";
import { InfoOutlineIcon, EmailIcon, SearchIcon } from "@chakra-ui/icons";
import { Button, Input, InputGroup, InputLeftElement, Modal, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Stack, Text } from "@chakra-ui/react";
import { UserDenied, CreateTxFailed, TxFailed, 
    TxUnspecifiedError, Timeout, TxResult, 
    useLCDClient, useConnectedWallet, useWallet 
} from '@terra-money/wallet-provider'
import { useState, useEffect } from 'react'
import { useQuery } from 'react-query'
import axios from 'axios';
import st_tx from "./TxModal.module.css";
import { toTerraAmount } from 'functions/toXAmount';
import { createAuthToken } from 'functions/createAuthToken';
import useChainId from 'functions/getChainIDs';
import { ethSend } from "components/Msgs/Msgs";
import { useChainAddress } from "state/global";
import { networkTypes, UKRAINE_POST_ROUTE, uMap } from "constants/constants";
import { ProviderWindow } from "types/types";
import { ethers } from "ethers";
import { queryFinder } from "functions/queryFinder";
import {
    FacebookIcon,
    FacebookShareButton,
    LinkedinShareButton,
    RedditShareButton,
    TelegramShareButton,
    TwitterIcon,
    TwitterShareButton,
  } from "react-share";

export enum TxStep {
    /*Before Wallet Signing*/
    Idle = 0,
    /*Before Wallet Signing*/

    /*Waiting for Wallet Signature*/
    Waiting = 1,
    /*Waiting for Wallet Signature*/

    /*Tx Hash created: Waiting for Info Query*/
    Hashed = 2,
    /*Tx Hash created: Waiting for Info Query*/

    /*Tx Broadcasted Successfully*/
    Success = 3,
    /*Tx Broadcasted Successfully*/

    /*Tx Broadcasted Successfully - ETH*/
    EthSuccess = 4,
    /*Tx Broadcasted Successfully - ETH*/

    /*Tx Failed*/
    Failed = 5,
    /*Tx Failed*/

    KYC = 6,

    KYCSuccess = 7,

    KYCFailed = 8,
}

const TxModal = ({ msgs, denom, amount }: { msgs: any, denom: string, amount: number }): JSX.Element => {
    const client = useLCDClient()
    const wallet = useConnectedWallet();
    const chain_id = useChainId();
    const [eth_address] = useChainAddress("address");
    const [network] = useChainAddress("network");

    const [open, setOpen] = useState<boolean>(false);
    const [txHash, setTxHash] = useState<string>('')
    const [status, setStatus] = useState<TxStep>(TxStep.Idle)
    const [error, setError] = useState<string>('')
    const [ethError, setEthError] = useState<any>();

    const initialKYC = {
      fullName: "",
      email: "",
      streetAddress: "",
      city: "",
      zipCode: "",
      country: "",
    };

    const initialWarning = {
        fullName: false, 
        email: false, 
        streetAddress: false,
        city: false,
        zipCode: false,
        country: false,
    }

    const [kycBody, setKYCBody] = useSetState<any>(initialKYC)
    const [kycWarning, setKycWarning] = useSetState<any>(initialWarning)

    const reset = () => {
        setStatus(TxStep.Idle)
        setTxHash('')
        setError('')
        setKYCBody(initialKYC);
        setKycWarning(initialWarning);
        setOpen(false)
    }

    const Dialog = ({type, title, img }: any) => {
        return (
            <div className={st_tx.dialog} style={{ 
                padding: status === TxStep.Success || 
                type === TxStep.EthSuccess || status === TxStep.Failed ? 
                "25px 50px" : "50px"
            }}>
                <img src={img} alt="tx"/>
                <div className={st_tx.title_tx}>
                    <h1>{title}</h1>
                    {((type !== TxStep.Waiting && type !== TxStep.Failed) 
                    && type !== TxStep.KYCSuccess && type !== TxStep.KYCFailed) && 
                    <h3>Tx Hash: <span><a href={queryFinder(txHash)} target="_blank">
                        {txHash.slice(0,5)}...{txHash.slice(-5)}</a></span>
                    </h3>
                    }
                </div>
                {(type === TxStep.Success || type === TxStep.EthSuccess) && 
                <>
                <div className={st_tx.success}>
                    <button onClick={() => window.location.reload()}>
                        Go Back
                    </button>
                    <button onClick={() => setStatus(TxStep.KYC)}>
                        Get Receipt
                    </button>
                </div>
                <div className={st_tx.socials}>
                    <TwitterShareButton 
                    title="I just donated to the Ukraine Humanitarian Relief Effort Drive on @AngelProtocol! Give once, give forever. Please join me in helping out the cause" 
                    hashtags={["ukraine"]} related={[]} url="https://ukraine.angelprotocol.io">
                        <TwitterIcon size={32} round/>
                    </TwitterShareButton>
                    <FacebookShareButton 
                    quote="I just donated to the Ukraine Humanitarian Relief Effort Drive on Angel Protocol! Give once, give forever. Please join me in helping out the cause" 
                    url="https://ukraine.angelprotocol.io">
                        <FacebookIcon size={32} round/>
                    </FacebookShareButton>
                </div>
                </>
                }
                {(type === TxStep.Failed || type === TxStep.KYCFailed || type === TxStep.KYCSuccess) && 
                    <>
                    <button onClick={() => window.location.reload()}>
                        Go Back
                    </button>
                    </>
                }
            </div>
        )
    }

    const validateEmail = (email: string) => {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    const submitKYC = async () => {
      let i = 0;

      Object.keys(kycBody).forEach((key: string) => {
        if (kycBody[key] === "") {
          setKycWarning({ [key]: true });
          i++;
        }
      });

      if (i > 0) {
        return;
      }

      const kyc_url = `https://9t0u8zpqjk.execute-api.us-east-1.amazonaws.com/donation?transactionId=${txHash}`;
      const generatedToken = createAuthToken();

      try {
        await axios.put(kyc_url, kycBody, {
          headers: {
            authorization: generatedToken,
          },
        });
        setStatus(TxStep.KYCSuccess);
      } catch (e) {
        setStatus(TxStep.KYCFailed);
      }
    };

    /* Query to get txInfo after Hash is created */
    const { data: txInfo } = useQuery(
      ["txInfo", txHash],
      () => {
        if (txHash === "" || txHash.includes("0x")) return;

        return client.tx.txInfo(txHash);
      },
      {
        enabled: status !== TxStep.Idle,
        retry: true,
        refetchOnReconnect: true,
        refetchOnWindowFocus: true,
        refetchOnMount: true,
      }
    );
    /* Query to get txInfo after Hash is created */

    useEffect(() => {
      if (msgs.length === 0 || !denom || (!wallet && eth_address === ""))
        return;

      if ((denom === "eth" || denom === "bnb") && typeof msgs[0] === "number") {
        (async () => {
          try {
            const { signer, tx } = await ethSend(
              eth_address,
              msgs[0],
              wallet?.walletAddress
                ? "XDEFI"
                : network.includes("bnb")
                ? "BINANCE"
                : "META"
            );
            setStatus(TxStep.Waiting);

            const response = await signer.sendTransaction(tx!);
            alert("testing");

            setTxHash(response.hash);
            setTimeout(() => {
              setStatus(TxStep.EthSuccess);
            }, 1000);
          } catch (e: any) {
            setEthError(e);
          }
        })();
      } else {
        if (!wallet) return;

        (async () => {
          setError("");

          let res: TxResult | string;

          try {
            if (!client) {
              throw new Error("Error in LCDClient");
            }

            setStatus(TxStep.Waiting);

            /* Wallet Transaction */
            res = await wallet.post({
              msgs,
            });

            setTxHash(res.result.txhash);
            setStatus(TxStep.Hashed);
            /* Wallet Transaction */
          } catch (error: unknown) {
            if (error instanceof UserDenied) {
              res = "User Denied";
              console.log(res);
            } else if (error instanceof CreateTxFailed) {
              res = "Create Tx Failed: " + error.message;
              console.log(res);
            } else if (error instanceof TxFailed) {
              res = "Tx Failed: " + error.message;
              console.log(res);
            } else if (error instanceof Timeout) {
              res = "Timeout";
            } else if (error instanceof TxUnspecifiedError) {
              res = "Unspecified Error: " + error.message;
              console.log(res);
            } else {
              res = error instanceof Error ? error.message : String(error);
              console.log(res);
            }
            setStatus(res === "User Denied" ? TxStep.Idle : TxStep.Failed);
            setError(res);
          }
        })();
      }
    }, [msgs]);

    useEffect(() => {
      if (
        txInfo != null &&
        txHash !== "" &&
        status !== TxStep.KYC &&
        status !== TxStep.KYCSuccess &&
        status !== TxStep.KYCFailed
      ) {
        if (txInfo.code) {
          setStatus(TxStep.Failed);
        } else {
          setTimeout(() => {
            setStatus(TxStep.Success);
          }, 200);
        }
      }
    }, [txInfo, txHash]);

    useEffect(() => {
      if (txHash === "") return;
      const generatedToken = createAuthToken();

      (async () => {
        let walletAddress: string;

        if (denom === "eth" && wallet?.walletAddress) {
          const xwindow = window as ProviderWindow;
          const provider = new ethers.providers.Web3Provider(
            xwindow.xfi?.ethereum!
          );
          const signer = provider.getSigner();
          walletAddress = await signer.getAddress();
        } else {
          walletAddress = wallet?.walletAddress ?? eth_address;
        }

        const body = {
          transactionId: txHash,
          transactionDate: new Date().toISOString(),
          chainId: chain_id!,
          amount: toTerraAmount(amount),
          splitLiq: "50",
          walletAddress,
          denomination: uMap.get(denom)?.toUpperCase(),
          fundId: +process.env.REACT_APP_FUND_ID!,
        };

        const config = {
          headers: {
            authorization: generatedToken,
          },
        };

        const res = await axios.post(UKRAINE_POST_ROUTE, body, config);
        console.log(res.status);
      })();
    }, [txHash]);

    useEffect(() => {
      if (status !== TxStep.Idle) {
        setOpen(true);
      }
    }, [status]);

    useEffect(() => {
      if (error === "User Denied") {
        setOpen(false);
        setStatus(TxStep.Idle);
      }
    }, [error]);

    useEffect(() => {
      if (ethError === undefined) return;
      setOpen(false);
      setStatus(TxStep.Idle);
    }, [ethError]);

    return (
      <Modal isCentered isOpen={open} onClose={() => null} size="sm">
        <ModalOverlay />
        <ModalContent>
          {status === TxStep.Waiting && (
            <Dialog
              img="images/angelwing_bl.png"
              title="Waiting on Wallet..."
              type={TxStep.Waiting}
            />
          )}
          {status === TxStep.Hashed && (
            <Dialog
              img="images/angelwing_bl.png"
              title="Broadcasting Transaction..."
              type={TxStep.Hashed}
            />
          )}
          {status === TxStep.Success && (
            <Dialog
              img="images/angelwing_bl.png"
              title="Transaction Successful!"
              type={TxStep.Success}
            />
          )}
          {status === TxStep.EthSuccess && (
            <Dialog
              img="images/angelwing_bl.png"
              title="Transaction Sent!"
              type={TxStep.EthSuccess}
            />
          )}
          {status === TxStep.KYC && (
            <>
              <ModalHeader>Receipt Form</ModalHeader>
              <ModalCloseButton onClick={reset} />
              <Stack
                padding="15px"
                maxHeight="400px"
                overflowY="scroll"
                gap="10px"
              >
                <Text>Full Name</Text>
                <InputGroup className={st_tx.input}>
                  <InputLeftElement
                    pointerEvents="none"
                    children={<InfoOutlineIcon color="gray.300" />}
                  />
                  <Input
                    isInvalid={kycWarning.fullName}
                    type="text"
                    placeholder="Dohn Joe"
                    onChange={(e) => {
                      if (e.target.value !== undefined) {
                        setKYCBody({ fullName: e.target.value });
                      }
                      setKycWarning({ fullName: false });
                    }}
                  />
                </InputGroup>
                <Text>Email</Text>
                <InputGroup className={st_tx.input}>
                  <InputLeftElement
                    pointerEvents="none"
                    children={<EmailIcon color="gray.300" />}
                  />
                  <Input
                    isInvalid={kycWarning.email}
                    type="text"
                    placeholder="snail@email.com"
                    onChange={(e) => {
                      if (
                        e.target.value !== undefined &&
                        validateEmail(e.target.value)
                      ) {
                        setKYCBody({ email: e.target.value });
                      }
                      setKycWarning({ email: false });
                    }}
                  />
                </InputGroup>
                <Text>Street Address</Text>
                <InputGroup className={st_tx.input}>
                  <InputLeftElement
                    pointerEvents="none"
                    children={<SearchIcon color="gray.300" />}
                  />
                  <Input
                    isInvalid={kycWarning.streetAddress}
                    type="text"
                    placeholder="404 Not Found Blvd"
                    onChange={(e) => {
                      if (e.target.value !== undefined) {
                        setKYCBody({ streetAddress: e.target.value });
                      }
                      setKycWarning({ streetAddress: false });
                    }}
                  />
                </InputGroup>
                <Text>City</Text>
                <InputGroup className={st_tx.input}>
                  <InputLeftElement
                    pointerEvents="none"
                    children={<SearchIcon color="gray.300" />}
                  />
                  <Input
                    isInvalid={kycWarning.city}
                    type="text"
                    placeholder="New York"
                    onChange={(e) => {
                      if (e.target.value !== undefined) {
                        setKYCBody({ city: e.target.value });
                      }
                      setKycWarning({ city: false });
                    }}
                  />
                </InputGroup>
                <Text>ZIP Code</Text>
                <InputGroup className={st_tx.input}>
                  <InputLeftElement
                    pointerEvents="none"
                    children={<SearchIcon color="gray.300" />}
                  />
                  <Input
                    isInvalid={kycWarning.zipCode}
                    type="text"
                    placeholder="01020"
                    onChange={(e) => {
                      if (e.target.value !== undefined) {
                        setKYCBody({ zipCode: e.target.value });
                      }
                      setKycWarning({ zipCode: false });
                    }}
                  />
                </InputGroup>
                <Text>Country</Text>
                <InputGroup className={st_tx.input}>
                  <InputLeftElement
                    pointerEvents="none"
                    children={<SearchIcon color="gray.300" />}
                  />
                  <Input
                    isInvalid={kycWarning.country}
                    type="text"
                    placeholder="Republic of Korea"
                    onChange={(e) => {
                      if (e.target.value !== undefined) {
                        setKYCBody({ country: e.target.value });
                      }
                      setKycWarning({ country: false });
                    }}
                  />
                </InputGroup>
                <Button
                  onClick={submitKYC}
                  padding="10px 0"
                  backgroundColor="#54A3D9"
                  color="white"
                >
                  Submit Form
                </Button>
              </Stack>
            </>
          )}
          {status === TxStep.KYCSuccess && (
            <Dialog
              img="images/angelwing_bl.png"
              title="Form Sent!"
              type={TxStep.KYCSuccess}
            />
          )}
          {status === TxStep.KYCFailed && (
            <Dialog
              img="images/angelwing_bl.png"
              title="Form Failed to Send :(!"
              type={TxStep.KYCFailed}
            />
          )}
          {status === TxStep.Failed && (
            <Dialog
              img="images/angelwing_bl.png"
              title="Transaction Failed :("
              type={TxStep.Failed}
            />
          )}
        </ModalContent>
      </Modal>
    );
}

export default TxModal;
